export class SearchCriteria {
  constructor(public farm?: string[],
              public site?: string[],
              public title?: string,
              public startDate?: Date,
              public endDate?: Date,
              public startMonth?: number,
              public startYear?: number,
              public endMonth?: number,
              public endYear?: number,
              public author?: string[],
              public accessionNo?: string) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/models/search-criteria.ts